import assetInformationChoicesApi from 'config/api/assetInformationChoices/assetInformationChoices';
import action_library_messages from 'messages/action_library_messages';
import booleanDictionary from 'services/_filters/booleanDictionary';

// Due Date Up To Filter
export const getDueDateUpToFilter = () => ({
  sectionName: action_library_messages.filters.due_date,
  filters: [
    { id: 'next_7_days', name: 'Next 7 days' },
    { id: 'next_30_days', name: 'Next 30 days' },
    { id: 'next_3_months', name: 'Next 3 months' },
  ],
  isSingleSelect: true,
});

// Is Overdue Filter
export const getIsOverdueFilter = () => ({
  sectionName: action_library_messages.filters.overdue,
  filters: booleanDictionary,
  isSingleSelect: true,
});

// Past Reminder Filter
export const getPastReminderFilter = () => ({
  sectionName: action_library_messages.filters.past_reminder,
  filters: booleanDictionary,
  isSingleSelect: true,
});

// Asset Importance Filter
export const getAssetImportanceFilter = async () => {
  const data = await assetInformationChoicesApi.getAssetInformationChoicesForFilters();
  return {
    sectionName: action_library_messages.filters.asset_importance,
    filters: data.assetsImportance,
    isSingleSelect: false,
  };
};
